import { Component, OnInit, OnDestroy, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { Subscription } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-filter-drawer',
  imports: [CommonModule, NzDrawerModule, NzButtonModule, NzIconModule, NzTooltipModule, NzDividerModule],
  templateUrl: './filter-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./filter-drawer.component.scss']
})
export class FilterDrawerComponent implements OnInit, OnDestroy {
  visible = false;
  width = 360;
  currentTemplate: TemplateRef<any> | null = null;
  footerExtra: TemplateRef<any> | null = null;
  private subs: Subscription[] = [];

  constructor(private filterSvc: FilterService) {}

  ngOnInit(): void {
    this.subs.push(
      this.filterSvc.visible$.subscribe((v) => (this.visible = v)),
      this.filterSvc.template$.subscribe((t) => (this.currentTemplate = t)),
      this.filterSvc.footerExtra$.subscribe((fe) => (this.footerExtra = fe)),
      this.filterSvc.width$.subscribe((w) => (this.width = w))
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  close() {
    this.filterSvc.close();
  }
  onApply() {
    this.filterSvc.emitApply();
  }
  onReset() {
    this.filterSvc.emitReset();
  }
}
